<div class="header" [ngClass]="{'on': headerVisible, 'open': headerOpen, 'alt': onMedicalPage}">
    <div class="bg"></div>

    <div class="content">
        <ng-container *ngIf="onMedicalPage">
            <p class="menu-text" (click)="goToCenter()">Return to<br> Products</p>
            <div class="arrow" (click)="goToCenter()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 21"><path fill="#85c440" d="M5.67 10.5L13 17.95 10.09 21 0 10.5 10.09 0 13 3.05 5.67 10.5z"/></svg>
            </div>
        </ng-container>

        <ng-container *ngIf="!onMedicalPage">
            <p class="menu-text" (click)="toggleHeader()">Menu</p>
            <img src="../../../assets/images/logo.svg" alt="Bayer" class="logo">
            <div class="arrow" (click)="toggleHeader()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 21"><path fill="#85c440" d="M5.67 10.5L13 17.95 10.09 21 0 10.5 10.09 0 13 3.05 5.67 10.5z"/></svg>
            </div>

            <div *ngIf="data" class="links">
                <div *ngFor="let link of data" class="link" [innerHTML]="link.text" (click)="linkClick(link)" [ngClass]="[link.url === currentPage ? 'active' : '', link.name ? link.name : '']"></div>
            </div>
        </ng-container>
    </div>
</div>
